module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"cpa":{"advertisingSettings":"広告設定","branchList":"[マスター]広告設定/一覧","thisBranch":"[店舗]広告設定"}},"en":{"cpa":{"advertisingSettings":"Advertising Settings","branchList":"branch list","thisBranch":"This branch"}}}')
  delete Component.options._Ctor
}
